<template>
  <div class="p-3 raised rounded">
    <div class="column-title border-bottom mb-2">Summary</div>
    <b-row>
      <b-col style="text-align: left">
        <span class="entity-data-label">
          Entity Name:
        </span>
      </b-col>
      <b-col style="text-align: left">
        <span class="entity-data-value">
          {{entity.name}}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: left">
        <span class="entity-data-label">
          Entity Type:
        </span>
      </b-col>
      <b-col style="text-align: left">
        <span class="entity-data-value">
          {{ maps.type[entity.type] }}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: left">
        <span class="entity-data-label">
          TAX ID:
        </span>
      </b-col>
      <b-col style="text-align: left">
        <span class="entity-data-value">
          {{entity.tin || '-'}}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: left">
        <span class="entity-data-label">
          Status:
        </span>
      </b-col>
      <b-col style="text-align: left">
        <span class="entity-data-value">Pending</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: left">
        <span class="entity-data-label">
          Status:
        </span>
      </b-col>
      <b-col style="text-align: left">
        <span class="entity-data-value">Pending</span>
      </b-col>
    </b-row>
    <entity-summary-address
      v-if="entity.businessAddress"
      :address="entity.businessAddress"
      prefix="Business"
      class="mt-3"
    />
    <entity-summary-address
      v-if="entity.mailingAddress"
      :address="entity.mailingAddress"
      prefix="Mailing"
      class="mt-3"
    />
    <b-row class="mt-3">
      <b-col style="text-align: left">
        <span class="entity-data-label">
          Phone:
        </span>
      </b-col>
      <b-col style="text-align: left">
      <span class="entity-data-value">
        {{ entity.phone }}
      </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ENTITY_TYPES from '@/components/entities/resources/entityTypes.json';
import PARTNERSHIP_TYPES from '@/components/entities/resources/partnership.json';
import EntitySummaryAddress from './EntitySummaryAddress';


export default {
  components: { EntitySummaryAddress },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maps: {
        type: ENTITY_TYPES,
        partnership: PARTNERSHIP_TYPES,
      },
    };
  },
};
</script>
<style scoped>
.column-title {
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}
.entity-data-label {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/EntitySummary.vue